import React from 'react'
import { Anchor, Divider, Grid, Stack, Text } from '@mantine/core'
import Badges from './Badges'
import { Link } from 'react-router'

const TITLE_COLS = { base: 12, md: 6 }
const LOCATION_COLS = { base: 12, md: 6 }

/**
 * Renders a job posting row.
 * @param {object} job the job posting to render the row for.
 * @param {string} color the color for the anchor.
 * @param {string} to where to redirect to when clicking on the anchor.
 * @param {boolean} openInNewTab whether the job posting should be loaded on a new tab or on the same browsing context.
 * @returns {JSX.Element}
 */
function JobPostingRow ({
  job,
  color,
  to,
  openInNewTab
}) {
  return (
    <Stack gap="xs">
      <Grid justify='space-between' align='center'>
        <Grid.Col span={TITLE_COLS}>
          <Anchor component={Link} target={openInNewTab ? '_blank' : '_self'} p="0" underline='never' fw={700} size="lg" variant="transparent" to={to} c={color}>{job.title}</Anchor>
          <Badges jobPosting={job} compact={true}/>
        </Grid.Col>
        <Grid.Col span={LOCATION_COLS}>
          <Text c="gray.8" size="lg">{job.location}</Text>
        </Grid.Col>
      </Grid>
      <Divider/>
    </Stack>
  )
}

export default React.memo(JobPostingRow)
